<template>
	<div class="indexes">
		<h2 class="indexes__title">Текущие индексы:</h2>
		<div class="indexes__data indexes-data">
			<div class="indexes-data__item" :value="rate.code" :key="rate.code"  v-for="rate in rates">
				<span class="indexes-data__currency-sign" v-html="rate.symbol"></span>
				<span class="indexes-data__currency-name">{{rate.code}}</span>
				<p class="indexes-data__exchange-rates">Курс: {{rate.rate_float}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		data: function() {
			return {
				timer: null
			}
		},
		created: function() {
			this.refreshData();
			this.timer = setInterval(this.refreshData, 10000)
		},
		computed: mapState({
			rates: state => state.indexes.rates
		}),
		methods: {
			refreshData () {
				this.$store.dispatch('indexes/getAllIndexes')
			}
		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
	}
</script>
